import ProtectedPrivateContainer from './ProtectedPrivateContainer';

export default ProtectedPrivateContainer;
